import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

let sisCheckboxId = 0;

@Component({
  selector: 'app-sis-checkbox',
  templateUrl: './sis-checkbox.component.html',
  styleUrls: ['./sis-checkbox.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SisCheckboxComponent),
      multi: true
    }
  ],
  standalone: false
})
export class SisCheckboxComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() ariaLabel: string | null = null;
  @Input() disabled = false;

  @Input()
  set checked(value: boolean) {
    this.checkedValue = value;
  }

  readonly inputId = `sis-checkbox-${++sisCheckboxId}`;
  checkedValue = false;
  private onChange: (value: boolean) => void = () => undefined;
  private onTouched: () => void = () => undefined;

  writeValue(value: unknown): void {
    this.checkedValue = value === true;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onChangeEvent(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.checkedValue = input.checked;
    this.onChange(this.checkedValue);
    this.onTouched();
  }
}
